// src/api/timesheets.js

import {get, post, patch, postFormData} from "@/lib/fetcher"

/**
 * Fetch a single timesheet from the API by job slug
 */

export async function getCandidateCompliances(){
    return await get ('/candidates/candidate_compliances')
}


export async function postCandidateCompliance(complianceTypeId, document){
    return await postFormData('/candidates/candidate_compliances', {compliance_type:complianceTypeId, document:document})
}
